<template>
    <div>
        <h5 class="f-title">
            {{word.suggested_users}}
        </h5>
        <div
            class="row match-grid-dash"
            style="margin-top: 18px;"
            v-if="people.length"
        >
            <div v-for="user in people" class="col-md-4 col-sm-6">
                <div
                    :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                    class="grid-avatar-dashboard"
                >
                    <a :href="'/dashboard/user/' + user.user_name">
                        <div class="match-cart-dashboard">
                            <h5>{{ user.name }}</h5>
                            <create-chat :user="user"></create-chat>
                        </div>
                    </a>

                </div>
            </div>
        </div>

        <div v-else class="alert alert-warning">
            <p>{{text.list_is_empty}}</p>
        </div>

        <div v-if="people.length" class="col-md-12 text-center">
            <a href="/dashboard/matches">
                <button class="btn text-center dash-all-Matches">
                    {{text.show_more_users}}
                </button>
            </a>
        </div>
    </div>
</template>

<script>
    import CreateChat from "../chats/CreateChat";

    export default {
        name: "suggested-users-list",

        components: {
            CreateChat
        },

        data() {
            return {
                people: [],
                word: window.word,
                text: window.text,
            }
        },

        methods: {
            fetchUsers() {
                axios.post('/dashboard/suggested-users/data').then(response => this.people = response.data.data);
            },
        },

        async mounted() {
            await this.fetchUsers();
        }
    };
</script>
